var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"join-img"},[_c('div',{staticClass:"bacImg"},[_c('h1',[_vm._v(_vm._s(_vm.$t('menu.job')))]),_c('a',{attrs:{"href":"https://www.hotjob.cn/wt/BCSC/web/index","target":"_blank"}},[_c('span',[_vm._v(_vm._s(_vm.$t('join.find')))]),_c('i',{staticClass:"iconfont iconjinru"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }